import React, { FC } from 'react';
import { Breadcrumbs as BPBreadcrumbs } from '@resideo/blueprint-react';
import { allRoutes } from 'config/navigationLeft';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Breadcrumb = ({ idx, chunks, t }) => {
  const routes = Object.values(allRoutes);
  let route = '';

  route = chunks.reduce((a, b, i) => (i <= idx ? `${a}/${b}` : a));

  const routeObj =
    idx === 0 ? allRoutes.myAccount : routes.find(e => e.linkPath === route);

  return (
    <Link to={routeObj?.linkPath as string}>
      {t(routeObj?.linkTextKey as string)}
    </Link>
  );
};

const Breadcrumbs: FC = () => {
  const { t } = useTranslation();
  const { pathname } = window.location;
  const chunks = pathname.split('/');

  return (
    <BPBreadcrumbs>
      {chunks.map((e, idx) => (
        <Breadcrumb key={e} idx={idx} chunks={chunks} t={t} />
      ))}
    </BPBreadcrumbs>
  );
};

export default Breadcrumbs;
